import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrophone } from "@fortawesome/free-solid-svg-icons";
import { ChatContext } from 'context/Context';
import classNames from 'classnames';

const Listen = () => {
    const { chatsLoading, listening, startListening } = useContext(ChatContext);
    return (
        <Button
            disabled={chatsLoading}
            variant="falcon-default"
            id="btnChatVoice"
            title="Use voice input"
            onClick={startListening}
        >
            <span className={classNames({ 'pulse-border': listening, })}><FontAwesomeIcon className={classNames({ 'text-secondary': !listening, 'text-primary': listening })} icon={faMicrophone} /></span>
        </Button>
    );
};

export default Listen;